<script>
    import Profile from './Profile.svelte';
	import Admin from './Admin.svelte';
	import Debts from './Debts.svelte';

    import { auth, googleProvider } from './firebase';
    import { authState } from 'rxfire/auth';

    let user;

    authState(auth).subscribe(u => {
		user = u;
	});

    function login() {
        auth.signInWithPopup(googleProvider);
    }
</script>


<section>
{#if user}
    <Profile user={user} />
    <button on:click={ () => auth.signOut() }>Logout</button>
    <hr>
	<Admin uid={user.uid} />
	<hr>
	<Debts uid={user.uid} />
{:else}
	<button on:click={login}>
		Signin with Google
	</button>
{/if}
</section>